<template>
  <div class="flex flex-col items-center justify-center text-center p-2 sm:p-6">
    <div class="rounded-full border-[10px] border-green-50 bg-green-100 p-6 mb-6 shadow-sm shadow-green-200">
      <Check class="w-10 h-10 text-green-500" />
    </div>
    <div class="w-full sm:w-2/3">
      <h2 class="text-xl font-semibold text-gray-900 mb-2">Termin angefragt</h2>
      <p class="text-sm text-gray-500 mb-6">
        Die Anfrage wurde erfolgreich übermittelt. Sobald der Termin bestätigt wurde, erfolgt eine Mitteilung per E-Mail.
      </p>
    </div>
    <button
      @click="onRestart"
      class="bg-primary text-white px-6 py-3 rounded-xl text-sm font-medium hover:bg-primary/90 hover:cursor-pointer transition shadow-sm shadow-primary/25"
    >
      Neue Anfrage starten
    </button>
  </div>
</template>

<script setup>
import { Check } from 'lucide-vue-next'

const emit = defineEmits(['restart'])

function onRestart() {
  emit('restart')
}
</script>
